module.exports = __webpack_public_path__ + "static/media/seglogic-billing.63aabb09.png";